import api from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  actions: {

    async findMovimentacaoByInvoiceId(_, { id }) {
      if (!id) throw new Error('O ID da Invoice é obrigatório.');
      const { data } = await api.get(`movimentacaoinvoice/invoice/${id}`);
      return data;
    },

    async findSpecificItem(_, filters) {
      if (!filters || !filters.buyerId || !filters.idContrato) {
        throw new Error('Os filtros idProduto, idContrato e idContratoVendaItem são obrigatórios.');
      }

      const { data } = await api.get('cadastrocontratovendaitem', { params: filters });
      return data;
    },

    async findMovimentacoesByBuyerId(_, params) {
      const { data } = await api.get('movimentacaoinvoice', { params });
      return data;
    },

    async findMovimentacoes(_, params) {
      const { data } = await api.get('movimentacaoinvoice', { params });
      return data;
    },

    async findDistinctPessoa(_, { where }) {
      const { data } = await api.get('movimentacaoinvoice/distinct', { params: where });
      return data;
    },

    async findDistinctCodigoPessoa(_, { codigo }) {
      const { data } = await api.get(`movimentacaoinvoice/distinct/${codigo}`);
      return data;
    },
  },
};
